import React, { useState } from "react";

import moment from "moment";

import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";

import {
  Button,
  IconButton,
  ButtonGroup,
  Box,
  Popper,
  ClickAwayListener,
  Paper,
  Tooltip,
} from "@mui/material";

import { CalendarMonthTwoTone, RotateLeftOutlined } from "@mui/icons-material";

const DatePicker = ({ formatString, dateFilter, setDateFilter, minimumDate }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const dateChanged = (date) => {
    setDateFilter({
      startDate: moment(date.start).format(formatString),
      endDate: moment(date.end).format(formatString),
    });

    setAnchorEl(null);
  };

  const handleOpenDatePickerClick = (event) => setAnchorEl(event.currentTarget);

  const handleDatePickerClose = () => setAnchorEl(null);

  const handleDateFilterRange = (date) => {
    switch (date) {
      case "today":
        setDateFilter({
          startDate: moment().format(formatString),
          endDate: moment().format(formatString),
        });
        break;
      case "thisweek":
        setDateFilter({
          startDate: moment().startOf("week").format(formatString),
          endDate: moment().endOf("week").format(formatString),
        });

        break;
      case "thismonth":
        setDateFilter({
          startDate: moment().startOf("month").format(formatString),
          endDate: moment().endOf("month").format(formatString),
        });

        break;
      case "thisquarter":
        setDateFilter({
          startDate: moment().startOf("quarter").format(formatString),
          endDate: moment().endOf("quarter").format(formatString),
        });

        break;
      case "yesterday":
        setDateFilter({
          startDate: moment().subtract(1, "days").format(formatString),
          endDate: moment().subtract(1, "days").format(formatString),
        });

        break;
      case "lastweek":
        setDateFilter({
          startDate: moment()
            .subtract(1, "weeks")
            .startOf("week")
            .format(formatString),
          endDate: moment()
            .subtract(1, "weeks")
            .endOf("week")
            .format(formatString),
        });

        break;
      case "lastmonth":
        setDateFilter({
          startDate: moment()
            .subtract(1, "months")
            .startOf("month")
            .format(formatString),
          endDate: moment()
            .subtract(1, "months")
            .endOf("month")
            .format(formatString),
        });

        break;
      case "lastquarter":
        setDateFilter({
          startDate: moment()
            .subtract(1, "quarters")
            .startOf("quarter")
            .format(formatString),
          endDate: moment()
            .subtract(1, "quarters")
            .endOf("quarter")
            .format(formatString),
        });

        break;
      default:
        setDateFilter({
          startDate: moment().startOf("month").format(formatString),
          endDate: moment().endOf("month").format(formatString),
        });
        break;
    }
    handleDatePickerClose();
  };

  return (
    <div className="analytics-filterBar">
      <div className="analytics-calendar">
        <Button
          variant="outlined"
          size="large"
          aria-describedby={Boolean(anchorEl) ? "date-popover" : undefined}
          onClick={handleOpenDatePickerClick}
          endIcon={<CalendarMonthTwoTone />}
          sx={{ fontSize: "14px", mr: 2 }}
        >
          Date Filter
        </Button>

        <Tooltip title="reset filter">
          <IconButton
            color="primary"
            aria-label="reset"
            component="span"
            onClick={() => handleDateFilterRange(null)}
          >
            <RotateLeftOutlined />
          </IconButton>
        </Tooltip>

        <Popper
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          role={undefined}
          placement="bottom-start"
        >
          <ClickAwayListener onClickAway={handleDatePickerClose}>
            <Paper sx={{ padding: 3 }}>
              <DateRangePicker
                minimumDate={moment(minimumDate).toDate()}
                firstOfWeek={1}
                numberOfCalendars={3}
                selectionType="range"
                singleDateRange={true}
                maximumDate={moment().toDate()}
                onSelect={(e) => dateChanged(e)}
                value={moment.range(dateFilter.startDate, dateFilter.endDate)}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  my: 2,
                }}
              >
                <ButtonGroup
                  size="large"
                  color="primary"
                  sx={{ marginBottom: 2 }}
                >
                  <Button onClick={() => handleDateFilterRange("today")}>
                    Today
                  </Button>
                  <Button onClick={() => handleDateFilterRange("thisweek")}>
                    This Week
                  </Button>
                  <Button onClick={() => handleDateFilterRange("thismonth")}>
                    This Month
                  </Button>
                  <Button onClick={() => handleDateFilterRange("thisquarter")}>
                    This Quarter
                  </Button>
                </ButtonGroup>
                <ButtonGroup size="large" color="primary">
                  <Button onClick={() => handleDateFilterRange("yesterday")}>
                    Yesterday
                  </Button>
                  <Button onClick={() => handleDateFilterRange("lastweek")}>
                    Last Week
                  </Button>
                  <Button onClick={() => handleDateFilterRange("lastmonth")}>
                    Last Month
                  </Button>
                  <Button onClick={() => handleDateFilterRange("lastquarter")}>
                    Last Quarter
                  </Button>
                </ButtonGroup>

                <Button
                  color="primary"
                  aria-label="Close Filter"
                  onClick={handleDatePickerClose}
                  sx={{ mt: 2 }}
                >
                  CLOSE
                </Button>
              </Box>
            </Paper>
          </ClickAwayListener>
        </Popper>
      </div>
      <h5 className="analytics-dateText">
        {`${
          dateFilter.startDate === dateFilter.endDate
            ? moment(dateFilter.startDate).format("MMM DD, YYYY")
            : moment(dateFilter.startDate).format("MMM DD, YYYY") +
              " - " +
              moment(dateFilter.endDate).format("MMM DD, YYYY")
        }`}
      </h5>
    </div>
  );
};

export default DatePicker;
